<template>
	<ConfirmationDialog
		className="image-dialog"
		:actions="actions"
	>
		<template v-slot:header>
			<div>
				{{ $t( "common.ImageDialog_urlFieldLabel" )}}
			</div>
		</template>

		<template v-slot:description>
			<div class="image-dialog__body">
				<TeamingTextbox
					name="imageSrc"
					:value="url"
					:focus="true"
					:isValid="isValidUrl"
					@input="onURLInput"
				/>
				<label>{{ $t( "common.ImageDialog_titleFieldLabel" ) }}</label>
				<TeamingTextbox
					name="imageTitle"
					:value="title"
					:focus="false"
					@input="onTitleInput"
				/>
				<div
					v-if="shouldShowValidationError"
					class="image-dialog__error"
				>
					{{ $t( "common.ImageDialog_invalidLinkMessage" ) }}
				</div>
			</div>
		</template>
	</ConfirmationDialog>
</template>

<script>
import * as KeyCode from "keycode-js";

import {
	ConfirmationDialog,
	TeamingTextbox
} from "@teaming/common-ui";

export default {
	name: "ImageDialog",
	components: {
		ConfirmationDialog,
		TeamingTextbox,
	},
	emits: [ "cancel", "submit", ],
	data() {
		return {
			url: "",
			title: "",
			saveAttempted: false,
		};
	},
	computed: {
		actions() {
			return [
				{
					id: "save",
					type: "PRIMARY",
					label: this.$t( "common.ImageDialog_saveBtnLabel" ),
					isDestructive: false,
					onButtonPress: () => {
						this.saveAttempted = true;
						if ( !this.shouldShowValidationError ) {
							const { url, title, } = this;
							this.$emit( "submit", { url, title, } );
						}
					},
				},
				{
					id: "cancel",
					type: "SECONDARY",
					label: this.$t( "common.ImageDialog_cancelBtnLabel" ),
					isDestructive: false,
					onButtonPress: () => {
						this.$emit( "cancel" );
					},
				},
			];
		},
		isValidUrl() {
			let u;
			if ( !this.saveAttempted ) {
				return true;
			}
			try {
				u = new URL( this.url );
			} catch {
				return false;
			}

			return u.protocol === "http:" || u.protocol === "https:";
		},
		shouldShowValidationError() {
			return this.url && !this.isValidUrl && this.saveAttempted;
		},
	},
	watch: {
		url( newVal, oldVal ) {
			if ( newVal && newVal !== oldVal ) {
				this.saveAttempted = true;
			}
		},
	},
	methods: {
		onURLInput( e ) {
			this.url = e.target.value;
		},
		onTitleInput( e ) {
			this.title = e.target.value.trim();
		},
		onKeyboardInput( e ) {
			const { url, title, } = this;
			if ( e.code === KeyCode.CODE_ESCAPE ) {
				return this.$emit( "cancel" );
			}
			if ( [ KeyCode.CODE_ENTER, KeyCode.CODE_RETURN, ].includes( e.code ) ) {
				this.$emit( "submit", { url, title, } );
			}
		},
	},
	mounted() {
		window.addEventListener( "keyup", this.onKeyboardInput );
	},
	beforeUnmount() {
		window.removeEventListener( "keyup", this.onKeyboardInput );
	},
};
</script>

<style lang="scss">
.image-dialog {
	.confirmation-dialog__content {
		width: 21.5rem;
	}
}

.image-dialog__error {
	@include font-and-line-for(-1);
	color: $danger-font-color;
}

.image-dialog__body {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;

	label {
		font-weight: 600;
		color: $default-font-color;
	}
}
</style>
